import {
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  Card,
  Grid,
  FormControl,
} from "@mui/material";
import { useEffect, useState, useCallback, useMemo } from "react";
import { HiTemplate } from "react-icons/hi";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import Appbar from "../../../components/Appbar";
import Body from "../../../components/Body";
import Drawer from "../../../components/Drawer";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { classGlobalApi } from "../../../store/class/classListGlobal";
import { subjectGlobalApi } from "../../../store/subject/subjectListGlobal";
import BackdropUI from "../../../ui/Backdrop";
import { eventAssignedObjectListApi, reseteventAssignedObjectList } from "../../../store/event-module/assignedObjectsListing";
import { moduleListingApi, resetModuleListing } from "../../../store/channel/moduleListing";
import NodataImg from "../../../assets/images/noData.png";
import ChannelAssignedModuleList from "./eventAssignedModuleList"
import ChannelModuleList from "./eventModuleList"
import AddExternalLink from "./AddExternalLink"
import PermissionGate from "../../../components/PermissionGate";

const categories = [
  { label: "All", value: "" },
  { label: "Podcast", value: "Podcast" },
  { label: "Courses", value: "Courses" },
  { label: "Short Videos", value: "ShortVideos" },
  { label: "Webinar", value: "Webinar" },
  { label: "Quiz", value: "Quiz" },
  { label: "Polls", value: "Polls" },
  { label: "External Links", value: "Externallink" }
];
export default function EventContent() {

  const { result: assignedObjectListResult, loading: assignedObjectLoading, total: assignedObjectTotal } = useSelector((state) => state?.assignedObjectList);
  const { result: moduleListingResult, loading: moduleListingLoading, total: moduleListingTotal } = useSelector((state) => state?.moduleListing);
  const { result: assignObjectToChannelResult, loading: assignObjectToChannelLoading } = useSelector((state) => state?.assignObjectToChannel);
  const schema = yup
    .object({})
    .required();
  const schemaEdit = yup
    .object({})
    .required();
  const params = useParams();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(params.id ? schemaEdit : schema),
    defaultValues: {},
  });
  const [channelCategory, setChannelCategory] = useState("");
  const [externalLinkModal, setExternalLinkModal] = useState(false)
  const [externalLinkDetail, setExternalLinkDetail] = useState()
  const [queryOptionsChangeAssignedModule, setQueryOptionsChangeAssignedModule] = useState({});
  const [queryOptionsChangeModuleListing, setQueryOptionsChangeModuleListing] = useState({});
  const [paginationModelChangeAssignedModule, setPaginationModelChangeAssignedModule] = useState({
    page: 0,
    pageSize: 20,
  });
  const [paginationModelChangeModuleListing, setPaginationModelChangeModuleListing] = useState({
    page: 0,
    pageSize: 20,
  });

  const paginationModelAssignedMemoized = useMemo(() => paginationModelChangeAssignedModule, [paginationModelChangeAssignedModule]);
  const paginationModelModuleListingMemoized = useMemo(() => paginationModelChangeModuleListing, [paginationModelChangeModuleListing]);

  const getRowSpacing = useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 5,
      bottom: params.isLastVisible ? 0 : 5,
    };
  }, []);
  const createQueryParams = useCallback((paginationModel, queryOptions) => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    return {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      search: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || '',
      event_id: params.id,
      content_type: String(channelCategory).toLocaleLowerCase(),
      type: channelCategory
    };
  }, [params.id, channelCategory]);

  const callObjectList = useCallback(() => {
    const queryAssignedModule = createQueryParams(paginationModelChangeAssignedModule, queryOptionsChangeAssignedModule);
    if (queryAssignedModule.content_type === "polls") {
      queryAssignedModule.content_type = "sundaypolls";
    } else if (queryAssignedModule.content_type.includes("courses")) {
      queryAssignedModule.content_type = "course";
    }
    dispatch(eventAssignedObjectListApi(queryAssignedModule));
  }, [createQueryParams, dispatch, paginationModelChangeAssignedModule, queryOptionsChangeAssignedModule])

  const callModulelistList = useCallback(() => {
    const queryModuleListing = createQueryParams(paginationModelChangeModuleListing, queryOptionsChangeModuleListing);
    dispatch(moduleListingApi(queryModuleListing));
  }, [paginationModelChangeModuleListing, queryOptionsChangeModuleListing, createQueryParams, dispatch])

  const handleChannelCategory = (category) => {
    setChannelCategory(category)
  }

  const NoRowsOverlay = () => (
    <Box
      sx={{
        textAlign: "center",
        py: 6,
        opacity: 0.8
      }}
    >
      <img src={NodataImg} width={400} alt="no data found" />
    </Box>
  );

  useEffect(() => {
    dispatch(classGlobalApi());
    dispatch(subjectGlobalApi());
  }, [params.id]);

  useEffect(() => {
    dispatch(reseteventAssignedObjectList())
    callObjectList()
  }, [paginationModelAssignedMemoized, queryOptionsChangeAssignedModule, channelCategory]);

  useEffect(() => {
    dispatch(resetModuleListing())
    callModulelistList()
  }, [paginationModelModuleListingMemoized, queryOptionsChangeModuleListing, channelCategory]);

  const handleOpenExternalLink = useCallback(((row) => {
    setExternalLinkDetail(row)
    setExternalLinkModal(true)
  }), [])

  const handleCloseExternalLink = useCallback((() => {
    setExternalLinkDetail()
    setExternalLinkModal(false)
  }), [])
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <Box sx={{ maxWidth: 1400, mx: "auto" }}>

          {/* HEADER */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              mb: 3,
              pb: 1,
              borderBottom: "1px solid #eee"
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1.2}>
              <HiTemplate size={22} />
              <Typography variant="h5" fontWeight={600}>
                Event Content
              </Typography>
            </Stack>
            <PermissionGate module="event" action="update">
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                  px: 2,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
                }}
                onClick={() => {
                  setExternalLinkModal(true)
                }}
              >
                Add External Link
              </Button>
            </PermissionGate>
          </Stack>


          {/* FILTER SECTION */}
          <Box mb={3}>
            <Grid container spacing={1.5}>

              {categories.map((cat) => {
                const active = channelCategory === cat.value;

                return (
                  <Grid item xs={12} sm={6} md={3} key={cat.label}>
                    <Card
                      onClick={() => handleChannelCategory(cat.value)}
                      sx={{
                        borderRadius: "10px",
                        border: active ? "2px solid #0caeeb" : "1px solid #e0e0e0",
                        background: active ? "#e6f7fd" : "#f7f7f7",
                        py: 1.4,
                        fontWeight: 500,
                        transition: "all .2s ease",
                        cursor: "pointer",
                        textAlign: "center",
                        "&:hover": {
                          borderColor: "#1da1d2",
                          background: "#f0fbff"
                        }
                      }}
                    >
                      <Box
                        sx={{
                          py: 1.6,
                          fontWeight: active ? 600 : 500,
                          color: active ? "#0caeeb" : "#4b5563"
                        }}
                      >
                        {cat.label}
                      </Box>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>

          {/* ASSIGNED CONTENT */}
          <Stack sx={{ mt: 4, mb: 1 }}>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{ mb: 1, color: "#374151" }}
            >
              Added to Event
            </Typography>
          </Stack>

          <Paper
            elevation={0}
            sx={{
              borderRadius: "10px",
              border: "1px solid #e5e7eb",
              background: "#fff"
            }}

          >
            <ChannelAssignedModuleList
              getRowSpacing={getRowSpacing}
              NoRowsOverlay={NoRowsOverlay}
              channelCategory={channelCategory}
              event_id={params.id}
              callModulelistList={callModulelistList}
              openExternalLink={handleOpenExternalLink}
              closeExternalLink={handleCloseExternalLink}
            />
          </Paper>


          {/* ADD NEW CONTENT */}
          <Stack sx={{ mt: 4, mb: 1 }}>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{ mb: 1, color: "#374151" }}
            >
              Available Content
            </Typography>
          </Stack>

          <Paper
            elevation={0}
            sx={{
              borderRadius: "10px",
              border: "1px solid #e5e7eb",
              background: "#fff"
            }}
          >
            <ChannelModuleList
              getRowSpacing={getRowSpacing}
              NoRowsOverlay={NoRowsOverlay}
              channelCategory={channelCategory}
              event_id={params.id}
              callObjectList={callObjectList}
            />
          </Paper>
        </Box>
        <AddExternalLink
          open={externalLinkModal}
          setOpen={setExternalLinkModal}
          event_id={params.id}
          refreshList={callObjectList}
          externalLinkDetail={externalLinkDetail}
          closeExternalLink={handleCloseExternalLink}
        />
      </Body>
      <BackdropUI open={moduleListingLoading || assignObjectToChannelLoading} />
    </>
  );
}